import React from 'react';
import { CardOptionsView } from '../../../Components/CardOptionsView/CardOptionsView';
import { CardOptionButton } from '../../../Components/CardOptionButton/CardOptionButton';
import { useHistory } from 'react-router-dom';

export interface ViewSelectWorkspaceProps {
  path: string;
}

export const ViewSelectWorkspace = ({
  path
}: ViewSelectWorkspaceProps): React.ReactElement<ViewSelectWorkspaceProps> => {
  const history = useHistory();

  return (
    <CardOptionsView>
      <CardOptionButton
        label="Contacts"
        icon="Open-Hand-1"
        onClick={() => history.push(`${path}/contacts`)}
      />
    </CardOptionsView>
  );
};
